var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "CommentTab" }, [
    _c("form", { attrs: { "data-form": "comment" } }, [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.comment,
            expression: "comment",
          },
        ],
        attrs: { placeholder: "Add your comment here..." },
        domProps: { value: _vm.comment },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.comment = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _vm.comment.length
      ? _c("div", { staticClass: "form-comment-slide-btns" }, [
          _c(
            "button",
            {
              staticClass: "btn lead-view-comment-post",
              on: { click: _vm.send },
            },
            [
              !_vm.isLoading && !_vm.isSuccess
                ? _c("span", [_vm._v("Post")])
                : _vm.isLoading
                ? _c("span", [_vm._v(_vm._s(_vm.translates.loading))])
                : _vm.isSuccess
                ? _c("span", { staticClass: "successful" }, [
                    _vm._v(_vm._s(_vm.translates.successful)),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn lead-view-comment-cancel",
              on: { click: _vm.cancel },
            },
            [_c("span", [_vm._v("Cancel")])]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }